"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components"); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var style = function style(p) {
  return (0, _styledComponents.css)(["background:none;border:none;padding:", " 0;&:hover,&:focus{border:none;}&:after{display:none;}", ""], p.size === 'small' ? p.theme.tokens.spacing03 : p.theme.tokens.spacing05, p.disabled ? (0, _styledComponents.css)(["cursor:not-allowed;color:", ";"], p.theme.colorTextButtonLinkDisabled) : (0, _styledComponents.css)(["color:", ";&:hover{color:", ";}"], p.theme.colorTextButtonLink, p.theme.colorTextButtonLinkHover));
};

var _default = style;
exports["default"] = _default;